<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 732 - ARV DISPENSING TOOL</div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total Patients</span>
        <span class="stat-number">{{ totalPatients }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">On 1st Line ARVs</span>
        <span class="stat-number">{{ firstLinePatients }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">On 2nd Line ARVs</span>
        <span class="stat-number">{{ secondLinePatients }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Adherence &gt;95%</span>
        <span class="stat-number">{{ adherenceGood }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="arv-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>CCC No</th>
            <th>Full Names</th>
            <th>Age</th>
            <th>Sex</th>
            <th>Contact</th>
            <th>Weight (kg)</th>
            <th>ART Regimen</th>
            <th>Line</th>
            <th>Months on ART</th>
            <th>Previous ARV</th>
            <th>Quantity Dispensed</th>
            <th>Days Supply</th>
            <th>Next Pickup Date</th>
            <th>Adherence Level</th>
            <th>Clinical Stage</th>
            <th>CD4 Count</th>
            <th>Viral Load</th>
            <th>TB Status</th>
            <th>Dispenser</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.date }}</td>
            <td>{{ record.cccNo }}</td>
            <td>{{ record.fullNames }}</td>
            <td>{{ record.age }}</td>
            <td class="text-center">{{ record.sex }}</td>
            <td>{{ record.contact }}</td>
            <td class="text-center">{{ record.weight }}</td>
            <td>{{ record.artRegimen }}</td>
            <td class="text-center">
              <span
                :class="record.line === '1st' ? 'first-line' : 'second-line'"
              >
                {{ record.line }} Line
              </span>
            </td>
            <td class="text-center">{{ record.monthsOnArt }}</td>
            <td>{{ record.previousArv }}</td>
            <td class="text-center">{{ record.quantity }}</td>
            <td class="text-center">{{ record.daysSupply }}</td>
            <td>{{ record.nextPickup }}</td>
            <td class="text-center">
              <span :class="getAdherenceClass(record.adherence)">
                {{ record.adherence }}%
              </span>
            </td>
            <td class="text-center">{{ record.clinicalStage }}</td>
            <td class="text-center">{{ record.cd4Count }}</td>
            <td class="text-center">{{ record.viralLoad }}</td>
            <td class="text-center">
              <span
                :class="
                  record.tbStatus === 'Positive'
                    ? 'positive-badge'
                    : 'negative-badge'
                "
              >
                {{ record.tbStatus }}
              </span>
            </td>
            <td>{{ record.dispenser }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="22" class="empty-row">
              No ARV dispensing records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH732ARV",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      arvRecords: [
        {
          date: "2026-04-22",
          cccNo: "CCC001",
          fullNames: "John Mwenda",
          age: 42,
          sex: "M",
          contact: "0712345678",
          weight: 68,
          artRegimen: "TDF/3TC/DTG (TLD)",
          line: "1st",
          monthsOnArt: 24,
          previousArv: "TDF/3TC/EFV",
          quantity: 90,
          daysSupply: 90,
          nextPickup: "2026-07-22",
          adherence: 98,
          clinicalStage: "Stage 1",
          cd4Count: 520,
          viralLoad: "Undetectable",
          tbStatus: "Negative",
          dispenser: "J. Karani",
          remarks: "Stable, good adherence",
        },
        {
          date: "2026-04-22",
          cccNo: "CCC002",
          fullNames: "Mary Wanjiku",
          age: 35,
          sex: "F",
          contact: "0723456789",
          weight: 62,
          artRegimen: "TDF/3TC/DTG (TLD)",
          line: "1st",
          monthsOnArt: 36,
          previousArv: "AZT/3TC/NVP",
          quantity: 60,
          daysSupply: 60,
          nextPickup: "2026-06-22",
          adherence: 96,
          clinicalStage: "Stage 1",
          cd4Count: 610,
          viralLoad: "Undetectable",
          tbStatus: "Negative",
          dispenser: "P. Muthoni",
          remarks: "Well controlled",
        },
        {
          date: "2026-04-21",
          cccNo: "CCC003",
          fullNames: "Peter Kimathi",
          age: 28,
          sex: "M",
          contact: "0734567890",
          weight: 70,
          artRegimen: "ABC/3TC/DTG",
          line: "1st",
          monthsOnArt: 12,
          previousArv: "None",
          quantity: 90,
          daysSupply: 90,
          nextPickup: "2026-07-21",
          adherence: 100,
          clinicalStage: "Stage 1",
          cd4Count: 580,
          viralLoad: "Undetectable",
          tbStatus: "Negative",
          dispenser: "J. Karani",
          remarks: "New on ART",
        },
        {
          date: "2026-04-20",
          cccNo: "CCC004",
          fullNames: "Grace Muthoni",
          age: 45,
          sex: "F",
          contact: "0745678901",
          weight: 65,
          artRegimen: "AZT/3TC/LPV/r",
          line: "2nd",
          monthsOnArt: 60,
          previousArv: "TDF/3TC/EFV",
          quantity: 60,
          daysSupply: 60,
          nextPickup: "2026-06-20",
          adherence: 92,
          clinicalStage: "Stage 2",
          cd4Count: 350,
          viralLoad: "1200",
          tbStatus: "Negative",
          dispenser: "P. Muthoni",
          remarks: "Monitor adherence",
        },
        {
          date: "2026-04-19",
          cccNo: "CCC005",
          fullNames: "James Mwirigi",
          age: 38,
          sex: "M",
          contact: "0756789012",
          weight: 72,
          artRegimen: "TDF/3TC/DTG (TLD)",
          line: "1st",
          monthsOnArt: 48,
          previousArv: "TDF/3TC/EFV",
          quantity: 90,
          daysSupply: 90,
          nextPickup: "2026-07-19",
          adherence: 97,
          clinicalStage: "Stage 1",
          cd4Count: 550,
          viralLoad: "Undetectable",
          tbStatus: "Negative",
          dispenser: "J. Karani",
          remarks: "Doing well",
        },
        {
          date: "2026-04-18",
          cccNo: "CCC006",
          fullNames: "Lucy Mwende",
          age: 29,
          sex: "F",
          contact: "0767890123",
          weight: 58,
          artRegimen: "TDF/3TC/DTG (TLD)",
          line: "1st",
          monthsOnArt: 6,
          previousArv: "None",
          quantity: 60,
          daysSupply: 60,
          nextPickup: "2026-06-18",
          adherence: 95,
          clinicalStage: "Stage 1",
          cd4Count: 420,
          viralLoad: "Undetectable",
          tbStatus: "Negative",
          dispenser: "P. Muthoni",
          remarks: "Adherence counselling given",
        },
        {
          date: "2026-04-17",
          cccNo: "CCC007",
          fullNames: "Esther Kendi",
          age: 52,
          sex: "F",
          contact: "0778901234",
          weight: 66,
          artRegimen: "AZT/3TC/NVP",
          line: "1st",
          monthsOnArt: 72,
          previousArv: "d4T/3TC/NVP",
          quantity: 30,
          daysSupply: 30,
          nextPickup: "2026-05-17",
          adherence: 88,
          clinicalStage: "Stage 2",
          cd4Count: 380,
          viralLoad: "2500",
          tbStatus: "Positive",
          dispenser: "J. Karani",
          remarks: "On TB treatment",
        },
        {
          date: "2026-04-16",
          cccNo: "CCC008",
          fullNames: "Samuel Mutuma",
          age: 8,
          sex: "M",
          contact: "0789012345",
          weight: 22,
          artRegimen: "ABC/3TC/LPV/r",
          line: "1st",
          monthsOnArt: 18,
          previousArv: "None",
          quantity: 60,
          daysSupply: 60,
          nextPickup: "2026-06-16",
          adherence: 98,
          clinicalStage: "Stage 1",
          cd4Count: 650,
          viralLoad: "Undetectable",
          tbStatus: "Negative",
          dispenser: "P. Muthoni",
          remarks: "Paediatric patient",
        },
        {
          date: "2026-04-15",
          cccNo: "CCC009",
          fullNames: "Naomi Gacheri",
          age: 34,
          sex: "F",
          contact: "0790123456",
          weight: 60,
          artRegimen: "TDF/3TC/DTG (TLD)",
          line: "1st",
          monthsOnArt: 30,
          previousArv: "TDF/3TC/EFV",
          quantity: 90,
          daysSupply: 90,
          nextPickup: "2026-07-15",
          adherence: 99,
          clinicalStage: "Stage 1",
          cd4Count: 590,
          viralLoad: "Undetectable",
          tbStatus: "Negative",
          dispenser: "J. Karani",
          remarks: "Excellent adherence",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.arvRecords;
      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.date >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.date <= this.dateTo);
      }
      return filtered;
    },
    totalPatients() {
      return this.filteredRecords.length;
    },
    firstLinePatients() {
      return this.filteredRecords.filter((r) => r.line === "1st").length;
    },
    secondLinePatients() {
      return this.filteredRecords.filter((r) => r.line === "2nd").length;
    },
    adherenceGood() {
      return this.filteredRecords.filter((r) => r.adherence >= 95).length;
    },
  },
  methods: {
    getAdherenceClass(adherence) {
      if (adherence >= 95) return "adherence-good";
      if (adherence >= 85) return "adherence-fair";
      return "adherence-poor";
    },
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.stat-number {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.arv-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10px;
  min-width: 1800px;
}

.arv-table th {
  background: #1f2937;
  color: white;
  padding: 8px 4px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.arv-table td {
  border: 1px solid #d1d5db;
  padding: 6px 4px;
  text-align: left;
}

.arv-table td.text-center {
  text-align: center;
}

.first-line {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.second-line {
  background: #fef3c7;
  color: #92400e;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.adherence-good {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.adherence-fair {
  background: #fef3c7;
  color: #92400e;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.adherence-poor {
  background: #fee2e2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.positive-badge {
  background: #fee2e2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.negative-badge {
  background: #d1fae5;
  color: #059669;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .arv-table {
    font-size: 7.5px;
    min-width: 0 !important;
  }

  .arv-table th {
    padding: 3px 2px;
    font-size: 7.5px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .arv-table td {
    padding: 3px 2px;
    font-size: 7px;
  }
}
</style>
